import styled from "styled-components";
import {ChangeEvent, useEffect, useState} from "react";
import {setCssProp} from "./ThemeChanger";


export default function TableSettings() {

    const [padding, setPadding] = useState<number>(0)

    function onPaddingChange(e: ChangeEvent<HTMLInputElement>) {
        let number = parseInt(e.target.value);
        if (isNaN(number))
            number = 6
        setPadding(Math.max(1, Math.min(10, number)))
        localStorage.setItem('td-padding', String(number))
        setCssProp("--td-padding", number * 2 + 'px')
    }

    useEffect(() => {
        let item = localStorage.getItem('td-padding');
        if (item === null)
            setPadding(6)
        else {
            let number = parseInt(item, 10);
            if (isNaN(number))
                number = 6
            setPadding(Math.max(1, Math.min(10, number)))
        }
    }, []);

    return <Container>
        <div className={'text'}>Таблиця</div>
        <div className="td-padding">
            <div>Щільність комірок(чим менше значення, тим щільніше)</div>
            <div>
                <input className={'input'} disabled={padding === 0}
                       onChange={e => onPaddingChange(e)}
                       value={padding} type="number" min={1} max={10}
                       step={1}/>
            </div>
        </div>
    </Container>
}


const Container = styled.div`

    display: flex;
    flex-flow: column;
    gap: .5rem;
    border-top: 2px solid var(--table-action-color);
    border-bottom: 2px solid var(--table-action-color);
    padding-top: .4rem;
    padding-bottom: .4rem;

    & .text {
        font-size: 1.2rem;

    }

    & .td-padding {
        & .input {
            font-size: 1rem;
            min-width: 2rem;
        }
    }
`
